/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum AdPlaybackEvent {
  /**
   * Player reaches the ad cue point/ ad slot
   */
  AD_BREAK_START = 'ad_break_start',
  /**
   * Player reaches the ad cue point end/ ad slot end
   */
  AD_BREAK_END = 'ad_break_complete',
  /**
   * Ad Playback started
   */
  AD_START = 'ad_start',
  /**
   * An ad has loaded and is ready to play
   */
  AD_ATTEMPT = 'ad_attempt',
  /**
   * The ad impression was tracked
   */
  AD_IMPRESSION = 'ad_impression',
  /**
   * Ad Playback ended
   */
  AD_END = 'ad_end',
  /**
   * User selected to skip the add
   */
  AD_SKIP = 'ad_skip',
  /**
   * Ad break was skipped by the ad frequency control (AFC / TrueView) policy
   */
  AD_SKIP_AFC_POLICY = 'ad_skip_afc_policy',
  /**
   * Ad playback metric
   */
  AD_PLAYBACK_METRIC = 'ad_playback_metric',
  /**
   * Ad was clicked
   */
  AD_VIEW = 'ad_view',
  /**
   * Ad playback error
   */
  AD_ERROR = 'ad_error',
  /**
   * Ad playback paused
   */
  AD_PAUSED_EVENT = 'ad_paused_event',
  /**
   * Ad playback resumed
   */
  AD_RESUMED_EVENT = 'ad_resumed_event',
  /**
   * Ad playback first quartile
   */
  AD_FIRST_QUARTILE_EVENT = 'ad_first_quartile_event',
  /**
   * Ad playback midpoint
   */
  AD_MIDPOINT_EVENT = 'ad_midpoint_event',
  /**
   * Ad playback third quartile
   */
  AD_THIRD_QUARTILE_EVENT = 'ad_third_quartile_event',
}
